import { render } from "./TermsComponent.vue?vue&type=template&id=74abd4b3&ts=true"
import script from "./TermsComponent.vue?vue&type=script&lang=ts"
export * from "./TermsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__